var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 60.1367H60.25V0.136719H0.25V60.1367Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95801 48.0462H37.2356C39.6491 48.0462 41.6058 46.0939 41.6058 43.676V15.9148L26.7491 1.03125H11.3282C8.91472 1.03125 6.95801 2.98349 6.95801 5.4014V48.0462Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95801 48.0462H37.2356C39.6491 48.0462 41.6058 46.0939 41.6058 43.676V15.9148L26.7491 1.03125H11.3282C8.91472 1.03125 6.95801 2.98349 6.95801 5.4014V48.0462Z",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5968 15.879H31.1192C28.7057 15.879 26.749 13.9268 26.749 11.5089V1.03125L41.5968 15.879Z",
    fill: "#BBDDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5968 15.879H31.1192C28.7057 15.879 26.749 13.9268 26.749 11.5089V1.03125L41.5968 15.879Z",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95743 5.98438H6.37534C3.97893 6.00229 2.04549 7.94557 2.04102 10.3456V48.6292C2.05534 51.0202 3.98609 52.9545 6.37534 52.9724H32.2828C33.4416 52.9724 34.5538 52.5157 35.3733 51.6918C36.1927 50.8769 36.653 49.7575 36.653 48.6023V48.0471H11.3276C8.91415 48.0471 6.95743 46.0948 6.95743 43.6769V5.98438Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95743 5.98438H6.37534C3.97893 6.00229 2.04549 7.94557 2.04102 10.3456V48.6292C2.05534 51.0202 3.98609 52.9545 6.37534 52.9724H32.2828C33.4416 52.9724 34.5538 52.5157 35.3733 51.6918C36.1927 50.8769 36.653 49.7575 36.653 48.6023V48.0471H11.3276C8.91415 48.0471 6.95743 46.0948 6.95743 43.6769V5.98438Z",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 29.0884H24.5102",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 21.3345H29.9998",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 25.2095H29.9998",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 20.9961,
    y: 28.1367,
    width: 32,
    height: 32,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8446 29.5509C45.6256 28.7699 46.892 28.7699 47.673 29.5509L51.5814 33.4593C52.3625 34.2404 52.3625 35.5067 51.5814 36.2878L31.6867 56.1825C31.3116 56.5576 30.8029 56.7683 30.2725 56.7683L24.3641 56.7683L24.3641 50.8599C24.3641 50.3294 24.5748 49.8207 24.9498 49.4457L44.8446 29.5509Z",
    fill: "#BBDDFF",
    stroke: "#4945FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.207 33.1875L47.9439 39.9243",
    stroke: "#4945FF",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/Custom.8a3b2f80cc4771cdb3c3c9fafa97e081.svg";
export { ForwardRef as ReactComponent };